export enum EUserType {
    Admin = "Admin",
    Coach = "Coach",
    Eleve = "Client"
}
  